import * as React from "react";
import type { ComponentProps } from "react";
import { cn } from "app/javascript/utils/index";
import { Input } from "app/javascript/components/ui/shadcn/input";

export type AppInputProps = ComponentProps<typeof Input>;

const AppInput = React.forwardRef<HTMLInputElement, AppInputProps>(
  ({ className, ...props }, ref) => (
    <Input
      ref={ref}
      className={cn(
        "h-auto bg-background focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-primary",
        className
      )}
      {...props}
    />
  )
);
AppInput.displayName = "AppInput";

export { AppInput };
